import { z } from 'zod';

export const PvPSubmodeKeySchema = z.enum(['GAME_SUBMODE_pvp1v1','GAME_SUBMODE_pvp2v2','GAME_SUBMODE_pvp3v3','GAME_SUBMODE_pvp5v5','GAME_SUBMODE_pvp7v7','GAME_SUBMODE_pvp11v11']);

export type PvPSubmodeKeyType = `${z.infer<typeof PvPSubmodeKeySchema>}`

export default PvPSubmodeKeySchema;
